import { InvestorDocumentTypeEnum } from '@shared/enums/investor-document-type.enum';

/**
 * Termos de adesão e ciência de risco da Horizon Trust (tenant id-fip).
 *
 * Cada perfil declarado no step "Tipo de investidor" (`perfilInvestidor`) tem
 * seu próprio template: o investidor baixa o modelo, assina e devolve o arquivo
 * assinado no mesmo cartão.
 *
 * PENDÊNCIA BACKEND: não existe tipo de documento próprio para termo de adesão
 * na tabela /investor-document-type — os dois termos sobem hoje como
 * SignedDocument (5 / 'DA'), o que os torna indistinguíveis no backend.
 * Quando os tipos novos forem criados, trocar `documentTypeId`/`documentTypeCode`
 * de cada entrada abaixo; nada mais precisa mudar.
 */
export interface RiskTermTemplate {
  /** Valor de `perfilInvestidor` que exige este termo. */
  profile: 'qualificado' | 'profissional';
  /** Nome do control no FormGroup do step. */
  formControlName: 'termoAdesaoQualificado' | 'termoAdesaoProfissional';
  title: string;
  description: string;
  /** Caminho relativo a `src/assets` do template para download. */
  assetPath: string;
  /** Nome sugerido ao salvar o template baixado. */
  downloadName: string;
  documentTypeId: InvestorDocumentTypeEnum;
  documentTypeCode: string;
}

export const RISK_TERM_TEMPLATES: readonly RiskTermTemplate[] = [
  {
    profile: 'qualificado',
    formControlName: 'termoAdesaoQualificado',
    title: 'Termo de Adesão e Ciência de Risco — Investidor Qualificado',
    description:
      'Baixe o modelo, assine e envie o arquivo assinado. Aplicável ao investidor qualificado.',
    assetPath: 'files/termo-adesao-ciencia-risco-qualificado.docx',
    downloadName: 'Termo de Adesão e Ciência de Risco - Qualificado.docx',
    documentTypeId: InvestorDocumentTypeEnum.SignedDocument,
    documentTypeCode: 'DA',
  },
  {
    profile: 'profissional',
    formControlName: 'termoAdesaoProfissional',
    title: 'Termo de Adesão e Ciência de Risco — Investidor Profissional',
    description:
      'Baixe o modelo, assine e envie o arquivo assinado. Aplicável ao investidor profissional.',
    assetPath: 'files/termo-adesao-ciencia-risco-profissional.docx',
    downloadName: 'Termo de Adesão e Ciência de Risco - Profissional.docx',
    documentTypeId: InvestorDocumentTypeEnum.SignedDocument,
    documentTypeCode: 'DA',
  },
] as const;

/** Extensões aceitas no envio do termo assinado. */
export const RISK_TERM_ACCEPTED_EXTENSIONS = ['.pdf', '.docx', '.doc', '.png', '.jpg', '.jpeg'];
